import BaseService from './baseService'; 



export class CurrentPrincipleService extends BaseService {
    constructor(){
        const baseUrl = "/Principals/current";
        super(baseUrl);
    }  
} 